import { useQuery } from '@hooks/reactQuery';

import { getOrganisationProjectsStatuses } from '@api/projectManagement';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_STATUSES } from '@constants/queryKeys';

interface IUseQueryProjectStatusesReturned {
	projectsStatuses: Array<TSelectOption>;
	isLoadingProjectsStatuses: boolean;
}

export const useQueryOrganisationProjectStatuses = (): IUseQueryProjectStatusesReturned => {
	const {
		data: projectsStatuses,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_STATUSES],
		allowedRoles: [
			EUserRoles.assetOwnerOrganizationAdministrator,
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.assetConsumerOrganizationAdministrator,
		],
		queryFn: getOrganisationProjectsStatuses,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectsStatuses: projectsStatuses || [],
		isLoadingProjectsStatuses: isInitialLoading || isFetching,
	};
};
